/**
 * App启动器，执行App业务和UI初始化操作
 */
export default abstract class BaseAppStarter {
    public constructor() {
        this.initAppServices();
        this.initAppUI();
    }

    protected abstract initAppServices();
    protected abstract initAppUI();
}
